/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
import {loadGeojson, FEATURED_WORKFLOW_BLOCK_PREFIX} from '@/blocks/featured_workflows/utils';

let featuredWorkflowsMooc = []

// WORKFLOW_1_1
const WORKFLOW_1_1_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_1`;
const WORKFLOW_1_1_XML = `<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_optical_data" id="${WORKFLOW_1_1_ID}" x="16" y="10" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">UK</field>
        <field name="data">_SR</field>
        <field name="fd">2019-04-01</field>
        <field name="td">2019-09-01</field>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">20</field>
                <next>
                    <block type="output_optical_vis" id="O{:OQ9A,GA/o*nLC6_D#" >
                        <field name="bandR">B4</field>
                        <field name="bandG">B3</field>
                        <field name="bandB">B2</field>
                        <field name="layerName">default</field>
                    </block>
                </next>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_1_1_TITLE = 'Introducing Earth Blox';
const WORKFLOW_1_1_DESC = `This workflow uses data from the European Space Agency's Sentinel 2 satellite. It measures light at several different wavelengths ("bands"). In this example we have only chosen the bands that correspond to red, green and blue. By allocating these bands to the RGB outputs, we get a "true colour" image.  Note that the dates are in the summer. Try changing the dates to observe different seasons.`;
const WORKFLOW_1_1_IMG = 'WORKFLOW_1_1.png';

const WORKFLOW_1_1 = {
    id: WORKFLOW_1_1_ID,
    xml: WORKFLOW_1_1_XML,
    title: WORKFLOW_1_1_TITLE,
    desc: WORKFLOW_1_1_DESC,
    img: WORKFLOW_1_1_IMG,
}
featuredWorkflowsMooc.push(WORKFLOW_1_1);

// EO --- WORKFLOW_1_1

// WORKFLOW_1_2
const WORKFLOW_1_2_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_2_OPTICAL`;
const WORKFLOW_1_2_XML = `<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_optical_data" id="${WORKFLOW_1_2_ID}" x="16" y="20" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2019-04-01</field>
        <field name="td">2019-09-01</field>
        <comment pinned="false" h="114.4281005859375" w="275.85791015625">Sentinel-2 is the European satellite that collects data in the visible and infrared parts of the spectrum.
        </comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">10</field>
                <next>
                    <block type="output_optical_vis" id="MaZ~;0QGh*FhO|7ha6" >
                        <field name="bandR">B4</field>
                        <field name="bandG">B3</field>
                        <field name="bandB">B2</field>
                        <field name="layerName">Sentinel2 true colou</field>
                        <comment pinned="false" h="117.2498779296875" w="326.24749755859375">By choosing the red, green and blue channels to visualise, we get the nearest thing to a "true colour" image, similar to a photograph.
                        </comment>
                    </block>
                </next>
            </block>
        </statement>
    </block>
    <block type="input_radar_data" id="${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_2_SAR" x="15" y="380" movable="true">
        <field name="dropdown">SAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd">2019-04-01</field>
        <field name="td">2019-09-01</field>
        <field name="orbit_dropdown">ASCENDING</field>
        <comment pinned="false" h="147.28753662109375" w="292.5179443359375">Sentinel-1 is Europe's radar satellite. It creates images by transmitting a series of microwave pulses and measuring the echoes coming back.
        </comment>
        <statement name="do">
            <block type="output_radar_vis" id="6Ed^{n@O2D1NE:P,,-F" >
                <field name="r">VV</field>
                <field name="g">VH</field>
                <field name="b">VV</field>
                <field name="param">.mean()</field>
                <field name="layerName">Sentinel1 Radar</field>
                <comment pinned="false" h="115.7056884765625" w="324.7056884765625">Radar systems collect different polarisations. Here we choose a combination of VV and VH polarisations to create a "false colour" image.
                </comment>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_1_2_TITLE = 'Explore different image types';
const WORKFLOW_1_2_DESC = 'In this example we examine two different kinds of sensor over the city of Edinburgh. The first block displays Sentinel-2 with bands chosen in the visible part of the spectrum to emulate a normal photograph.  The second block is for Sentinel-1, a radar satellite that measures in the microwave part of the spectrum. ';
const WORKFLOW_1_2_IMG = 'WORKFLOW_1_2.png';
import WORKFLOW_1_2_AREA from './featured_workflows/areas/WORKFLOW_1_2_AREA.js'

let WORKFLOW_1_2_GEOJSON = loadGeojson(WORKFLOW_1_2_AREA)

if(WORKFLOW_1_2_GEOJSON !== false) {
    const WORKFLOW_1_2 = {
        id: WORKFLOW_1_2_ID,
        xml: WORKFLOW_1_2_XML,
        title: WORKFLOW_1_2_TITLE,
        desc: WORKFLOW_1_2_DESC,
        img: WORKFLOW_1_2_IMG,
        area: WORKFLOW_1_2_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_2);
}

// EO --- WORKFLOW_1_2

// WORKFLOW_1_3
const WORKFLOW_1_3_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_3`;
const WORKFLOW_1_3_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_radar_data" id="${WORKFLOW_1_3_ID}" x="20" y="20" movable="true">
        <field name="dropdown">SAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd">2021-04-13</field>
        <field name="td">2021-04-17</field>
        <field name="orbit_dropdown">BOTH</field>
        <comment pinned="false" h="178.62623596191406" w="253.9296875">With "both" selected, this radar block is finding data from both the ascending (South-to-North) and descending (N-to-S) paths of the orbit. Optical sensors don't have this option because only one side is in sunlight (the other is on the nighttime side).  </comment>
        <statement name="do">
            <block type="output_radar_vis" id="oU5ybUSrVoJppf1@xttv" movable='false'>
                <field name="r">VV</field>
                <field name="g">VV</field>
                <field name="b">VV</field>
                <field name="param">.mean()</field>
                <field name="layerName">default</field>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_1_3_TITLE = 'Observe the impact of orbit coverage';
const WORKFLOW_1_3_DESC = 'This workflow illustrates the impact of the satellite orbit on the data that is collected.  The examples shows Sentinel-1 images over the Caribbean for a short period of time (1 week) so that you can see the way the satellite collects strips of data. Try changing the "orbit" selection to "ascending" or "descending" to compare the difference in the image strips.';
const WORKFLOW_1_3_IMG = 'WORKFLOW_1_3.png';
import WORKFLOW_1_3_AREA from './featured_workflows/areas/WORKFLOW_1_3_AREA.js'

let WORKFLOW_1_3_GEOJSON = loadGeojson(WORKFLOW_1_3_AREA)

if(WORKFLOW_1_3_GEOJSON !== false) {
    const WORKFLOW_1_3 = {
        id: WORKFLOW_1_3_ID,
        xml: WORKFLOW_1_3_XML,
        title: WORKFLOW_1_3_TITLE,
        desc: WORKFLOW_1_3_DESC,
        img: WORKFLOW_1_3_IMG,
        area: WORKFLOW_1_3_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_3);
}

// EO --- WORKFLOW_1_3

// WORKFLOW_1_4b
const WORKFLOW_1_4b_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_4b`;
// const WORKFLOW_1_4b_XML = ``;
const WORKFLOW_1_4b_TITLE = 'See some weird things in google maps 1';
const WORKFLOW_1_4b_DESC = 'Our second example on obsured images in Google Maps, takes us to Cattenom Nuclear Power Plant in France, where the main features of the power station is apparent, but it has been pixelated enough to blur the details. Compare this lack of detail with the houses just a short distance to the south of the power station.';
const WORKFLOW_1_4b_IMG = 'WORKFLOW_1_4b.png';
import WORKFLOW_1_4b_AREA from './featured_workflows/areas/WORKFLOW_1_4b_AREA.js'

let WORKFLOW_1_4b_GEOJSON = loadGeojson(WORKFLOW_1_4b_AREA)

if(WORKFLOW_1_4b_GEOJSON !== false) {
    const WORKFLOW_1_4b = {
        id: WORKFLOW_1_4b_ID,
        title: WORKFLOW_1_4b_TITLE,
        desc: WORKFLOW_1_4b_DESC,
        img: WORKFLOW_1_4b_IMG,
        area: WORKFLOW_1_4b_GEOJSON,
        mapType: 'satellite',
        isAreaOnly: true
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_4b);
}

// EO --- WORKFLOW_1_4b

// WORKFLOW_1_4a
const WORKFLOW_1_4a_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_4a`;
// const WORKFLOW_1_4a_XML = ``;
const WORKFLOW_1_4a_TITLE = 'See some weird things in google maps 2';
const WORKFLOW_1_4a_DESC = 'When looking at the "satellite" option on the map, you are seeing commercial satellite imagery supplied to Google. They augment this with aerial photographs in some places, usually cities.  But in some locations are, Google obscures the view.  In this example we look at Ayioi Anargyroi Military Base in Athens.  Compare the image in the centre with the surrounding city streets. The base has been blurred out.';
const WORKFLOW_1_4a_IMG = 'WORKFLOW_1_4a.png';
import WORKFLOW_1_4a_AREA from './featured_workflows/areas/WORKFLOW_1_4a_AREA.js'

let WORKFLOW_1_4a_GEOJSON = loadGeojson(WORKFLOW_1_4a_AREA)

if(WORKFLOW_1_4a_GEOJSON !== false) {
    const WORKFLOW_1_4a = {
        id: WORKFLOW_1_4a_ID,
        title: WORKFLOW_1_4a_TITLE,
        desc: WORKFLOW_1_4a_DESC,
        img: WORKFLOW_1_4a_IMG,
        area: WORKFLOW_1_4a_GEOJSON,
        mapType: 'satellite',
        isAreaOnly: true
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_4a);
}

// EO --- WORKFLOW_1_4a

// WORKFLOW_1_5
const WORKFLOW_1_5_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_5_L8`;
const WORKFLOW_1_5_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_optical_data" id="${WORKFLOW_1_5_ID}" x="28" y="58" movable="true">
        <field name="dropdown">l8</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2018-04-01</field>
        <field name="td">2018-09-30</field>
        <comment pinned="false" h="80" w="160">The Landsat-8 satellite images have 30m pixels.</comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">20</field>
                <next>
                    <block type="output_optical_vis" id="he-Kk}s7T*R+Hi+{O=+Y" >
                        <field name="bandR">SR_B4</field>
                        <field name="bandG">SR_B3</field>
                        <field name="bandB">SR_B2</field>
                        <field name="layerName">Landsat 8  30m</field>
                    </block>
                </next>
            </block>
        </statement>
    </block>
    <block type="input_optical_data" id="${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_5_S2" x="28" y="410" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2018-04-01</field>
        <field name="td">2018-09-30</field>
        <comment pinned="false" h="80" w="160">The Sentinel-2 satellite images have 10m pixels.</comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">20</field>
                <next>
                    <block type="output_optical_vis" id="DMlZ.$DnI7v}Q:BO6nso" >
                        <field name="bandR">B4</field>
                        <field name="bandG">B3</field>
                        <field name="bandB">B2</field>
                        <field name="layerName">Sentinel 2 10m</field>
                    </block>
                </next>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_1_5_TITLE = 'Comparing level of detail in different images';
const WORKFLOW_1_5_DESC = 'This example compares detail that is visible in Landsat 8 (with a 30m pixel size) and Sentinel-2 (with 10m).  The area is a region of Edinburgh that includes a park called "The Meadows".  The criss-crossing pathways on The Meadows helps to illustrate the difference in image detail.  You can also make both layers transparent and switch on "satellite" view on maps to make a comparison with very high resolution satellite imagery.  (Note that some imagery in Google Maps is from aircraft, not satellites).  ';
const WORKFLOW_1_5_IMG = 'WORKFLOW_1_5.png';
import WORKFLOW_1_5_AREA from './featured_workflows/areas/WORKFLOW_1_5_AREA.js'

let WORKFLOW_1_5_GEOJSON = loadGeojson(WORKFLOW_1_5_AREA)

if(WORKFLOW_1_5_GEOJSON !== false) {
    const WORKFLOW_1_5 = {
        id : WORKFLOW_1_5_ID,
        xml: WORKFLOW_1_5_XML,
        title: WORKFLOW_1_5_TITLE,
        desc: WORKFLOW_1_5_DESC,
        img: WORKFLOW_1_5_IMG,
        area: WORKFLOW_1_5_GEOJSON,
        mapType: 'satellite'
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_5);
}

// EO --- WORKFLOW_1_5

// WORKFLOW_1_6
const WORKFLOW_1_6_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_6_S2_Green`;
const WORKFLOW_1_6_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_optical_data" id="${WORKFLOW_1_6_ID}" x="20" y="43" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2019-04-01</field>
        <field name="td">2019-09-01</field>
        <comment pinned="false" h="117.09857177734375" w="280.96160888671875">Sentinel-2 is the European satellite that collects data in 12 different bands within the visible and infrared parts of the spectrum.</comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">10</field>
                <next>
                    <block type="output_optical_vis" id="MaZ~;0QGh*FhO|7ha6" >
                        <field name="bandR">B3</field>
                        <field name="bandG">B3</field>
                        <field name="bandB">B3</field>
                        <field name="layerName">Sentinel2 Green</field>
                        <comment pinned="false" h="115.70018005371094" w="280.09463500976562">By choosing the red, green and blue channels to the same band value (in this case "B3(Green)" we can visualise just one band at a time (as a B&amp;W image).</comment>
                    </block>
                </next>
            </block>
        </statement>
    </block>
    <block type="input_optical_data" id="${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_1_6_S2_Blue" x="20" y="400" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2019-04-01</field>
        <field name="td">2019-09-01</field>
        <comment pinned="false" h="146.30531311035156" w="280.68734741210938">This block shows the blue band (B2). Once you have looked at this band and compared with the green one, try changing the R, G and B menus to "B8(NIR)" for each of them. Then compare with the green channel.</comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">10</field>
                <next>
                    <block type="output_optical_vis" id="bg;767N[;,W@TI%nM6X" >
                        <field name="bandR">B2</field>
                        <field name="bandG">B2</field>
                        <field name="bandB">B2</field>
                        <field name="layerName">Sentinel2 Blue</field>
                        <comment pinned="false" h="106.0771484375" w="250.16409301757812">If you change the RGB bands, remember to change the "Layer name" also, so you can keep track of the layers.</comment>
                    </block>
                </next>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_1_6_TITLE = 'See different bands';
const WORKFLOW_1_6_DESC = 'This example compares different spectral bands of Sentinel 2 over New York City. When opened and run, it shows two bands:  the green band (B3) and the blue band (B1).  The difference between these bands is very subtle, and even over Central Park, the green band is only slightly brighter than the blue. Now change all three "B2(Blue)" to "B8{NIR)" in the second block and observe the striking contrast in the NIR between buildings and vegetation.';
const WORKFLOW_1_6_IMG = 'WORKFLOW_1_6.png';
import WORKFLOW_1_6_AREA from './featured_workflows/areas/WORKFLOW_1_6_AREA.js'

let WORKFLOW_1_6_GEOJSON = loadGeojson(WORKFLOW_1_6_AREA)

if(WORKFLOW_1_6_GEOJSON !== false) {
    const WORKFLOW_1_6 = {
        id: WORKFLOW_1_6_ID,
        xml: WORKFLOW_1_6_XML,
        title: WORKFLOW_1_6_TITLE,
        desc: WORKFLOW_1_6_DESC,
        img: WORKFLOW_1_6_IMG,
        area: WORKFLOW_1_6_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_1_6);
}

// EO --- WORKFLOW_1_6

// WORKFLOW_2_1
const WORKFLOW_2_1_ID = '${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_2_1';
const WORKFLOW_2_1_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_climate_data" id="${WORKFLOW_2_1_ID}" x="30" y="30" movable="true">
        <field name="dropdown">nrti_cloud</field>
        <field name="param">cloud_fraction</field>
        <field name="area">Area 1</field>
        <field name="fd">2019-03-01</field>
        <field name="td">2019-03-16</field>
        <statement name="do">
            <block type="analyse_timeseries" id="xytfQj+NN]kO1!W?B:Wz" >
                <field name="interval">daily</field>
                <statement name="statements">
                    <block type="output_other_vis" id="/9oPv%IWp[5ZCe0(EIP3" >
                        <field name="layerName">default</field>
                    </block>
                </statement>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_2_1_TITLE = 'Animate Cloud Cover';
const WORKFLOW_2_1_DESC = 'This example shows a time series of the cloud formation before, during and after typhoon Idai in 2019.  This data is from ESA’s Sentinel 5 satellite and records the cloud cover, with the time series in daily steps.  You can drag the date indicator on the time series timeline.  Notice how the storm forms at the beginning of the month, with the cyclone building up to a peak on the 14th March, making landfall on the coast of Mozambique a day later.';
const WORKFLOW_2_1_IMG = 'WORKFLOW_2_1.png';
import WORKFLOW_2_1_AREA from './featured_workflows/areas/WORKFLOW_2_1_AREA.js'

let WORKFLOW_2_1_GEOJSON = loadGeojson(WORKFLOW_2_1_AREA)

if(WORKFLOW_2_1_GEOJSON !== false) {
    const WORKFLOW_2_1 = {
        id: WORKFLOW_2_1_ID,
        xml: WORKFLOW_2_1_XML,
        title: WORKFLOW_2_1_TITLE,
        desc: WORKFLOW_2_1_DESC,
        img: WORKFLOW_2_1_IMG,
        area: WORKFLOW_2_1_GEOJSON,
        mapType: 'satellite'
    }
    featuredWorkflowsMooc.push(WORKFLOW_2_1);
}

// EO --- WORKFLOW_2_1

// WORKFLOW_2_2
const WORKFLOW_2_2_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_2_2`;
const WORKFLOW_2_2_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_climate_data" id="${WORKFLOW_2_2_ID}_OCEAN" x="30" y="53" movable="true">
        <field name="dropdown">chlorophyll</field>
        <field name="param">sst</field>
        <field name="area">Area 1</field>
        <field name="fd">2018-04-01</field>
        <field name="td">2019-05-01</field>
        <comment pinned="false" h="100.2255859375" w="211.464599609375">This examples shows sea surface temperature from NASA's MODIS satellite covering the 2018/19 El Niño.</comment>
        <statement name="do">
            <block type="analyse_timeseries" id="zZb6:L[wSR*Rg=Aw0jLz" >
                <field name="interval">monthly</field>
                <comment pinned="false" h="80" w="160">This time series will average all the data within each month.</comment>
                    <statement name="statements">
                        <block type="output_other_vis" id=")o;?o3NbczYhAz3slW|@" >
                            <field name="layerName">Sea Surface Temp SST</field>
                        </block>
                    </statement>
                </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_2_2_TITLE = 'Animate Sea surface temperature';
const WORKFLOW_2_2_DESC = `This workflow looks at a time series of sea surface temperature (SST) from NASA's MODIS satellite, with the dates spanning the El Niño event that began in December 2018.  The time series is at monthly intervals, so that the SST is average over an entire month.  Since this is a large area and a long time series, it may take some time to process the data. Be patient, as it is trying to process data every day over the entire Southern Pacific.`;
const WORKFLOW_2_2_IMG = 'WORKFLOW_2_2.png';
import WORKFLOW_2_2_AREA from './featured_workflows/areas/WORKFLOW_2_2_AREA.js'

let WORKFLOW_2_2_GEOJSON = loadGeojson(WORKFLOW_2_2_AREA)

if(WORKFLOW_2_2_GEOJSON !== false) {
    const WORKFLOW_2_2 = {
        id: WORKFLOW_2_2_ID,
        xml: WORKFLOW_2_2_XML,
        title: WORKFLOW_2_2_TITLE,
        desc: WORKFLOW_2_2_DESC,
        img: WORKFLOW_2_2_IMG,
        area: WORKFLOW_2_2_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_2_2);
}

// EO --- WORKFLOW_2_2

// WORKFLOW_2_3
const WORKFLOW_2_3_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_2_3`;
const WORKFLOW_2_3_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_atmospheric_data" id="${WORKFLOW_2_3_ID}" x="20" y="30" movable="true">
        <field name="dropdown">ozone</field>
        <field name="area">Area 1</field>
        <field name="fd">2019-04-08</field>
        <field name="td">2021-04-17</field>
        <statement name="do">
            <block type="analyse_timeseries" id="QKsy#uG0JcCKc;R[?a{+" >
                <field name="interval">monthly</field>
                <statement name="statements">
                    <block type="output_other_vis" id="BJKVm4/m/,Sy$)ELqQHJ" >
                        <field name="layerName">default</field>
                    </block>
                </statement>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_2_3_TITLE = 'Ozone concentration';
const WORKFLOW_2_3_DESC = `
This workflow shows a monthly interval time series for 2 years of ozone measurements over the Southern Hemisphere.  Data does not appear during May-August towards the Southern polar regions since this is winter time, and these satellite measurements require sunlight. When you run the workflow, note how there are always higher levels (oranges and yellows) near the equator where the more direct sunshine boosts the creation of ozone.  However, in the Antarctic spring (Sept-Oct) the sudden increase in sunshine promotes a chemical reaction that severely depletes the ozone (blue hues). This is indicative of the formation of the so called “ozone hole”. While this seasonal feature still persists today, it is lower than it was in the 1980s when CFC production was at its peak.`;
const WORKFLOW_2_3_IMG = 'WORKFLOW_2_3.png';
import WORKFLOW_2_3_AREA from './featured_workflows/areas/WORKFLOW_2_3_AREA.js'

let WORKFLOW_2_3_GEOJSON = loadGeojson(WORKFLOW_2_3_AREA)

if(WORKFLOW_2_3_GEOJSON !== false) {
    const WORKFLOW_2_3 = {
        id: WORKFLOW_2_3_ID,
        xml: WORKFLOW_2_3_XML,
        title: WORKFLOW_2_3_TITLE,
        desc: WORKFLOW_2_3_DESC,
        img: WORKFLOW_2_3_IMG,
        area: WORKFLOW_2_3_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_2_3);
}

// EO --- WORKFLOW_2_3

// WORKFLOW_3_1
const WORKFLOW_3_1_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_3_1`;
const WORKFLOW_3_1_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_radar_data" id="${WORKFLOW_3_1_ID}" x="20" y="30" movable="true">
        <field name="dropdown">SAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd">2021-01-31</field>
        <field name="td">2021-04-06</field>
        <field name="orbit_dropdown">BOTH</field>
        <comment pinned="false" h="161.35809326171875" w="235.6705322265625">The Sentinel-1 radar system has weekly data almost everywhere on the planet. "Both" is chosen so that both the northward and the southward orbital passes are included.</comment>
        <statement name="do">
            <block type="analyse_timeseries" id=";du80PGQUNhlJLe]yTbq" >
                <field name="interval">weekly</field>
                <comment pinned="false" h="80" w="240">Weekly is enough here to capture the ice shelf break off.</comment>
                <statement name="statements">
                    <block type="output_radar_vis" id="@tT%,0otfXlDm=FkP_!!" >
                        <field name="r">HH</field>
                        <field name="g">HH</field>
                        <field name="b">HH</field>
                        <field name="param">.mean()</field>
                        <field name="layerName">Sentinel 1 radar</field>
                        <comment pinned="false" h="128.04718017578125" w="257.5966796875">In the polar regions the Sentinel-1 radar measures only with HH and HV. If you look outside of the polar regions, you will have to choose VV or VH.</comment>
                    </block>
                </statement>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_3_1_TITLE = 'Brunt Ice Shelf';
const WORKFLOW_3_1_DESC = 'This workflow uses Sentinel-1 radar images over the period January-April 2021, and creates an animated time series so that you can see how the crack in the ice expands just before the iceberg completely detaches from the main ice shelf.  The advantage of using radar here is that it can see through the clouds, so an image is guaranteed every week. ';
const WORKFLOW_3_1_IMG = 'WORKFLOW_3_1.png';
import WORKFLOW_3_1_AREA from './featured_workflows/areas/WORKFLOW_3_1_AREA.js'

let WORKFLOW_3_1_GEOJSON = loadGeojson(WORKFLOW_3_1_AREA)

if(WORKFLOW_3_1_GEOJSON !== false) {
    const WORKFLOW_3_1 = {
        id: WORKFLOW_3_1_ID,
        xml: WORKFLOW_3_1_XML,
        title: WORKFLOW_3_1_TITLE,
        desc: WORKFLOW_3_1_DESC,
        img: WORKFLOW_3_1_IMG,
        area: WORKFLOW_3_1_GEOJSON
    }
    console.log('workflow 3_1', WORKFLOW_3_1)
    featuredWorkflowsMooc.push(WORKFLOW_3_1);
}

// EO --- WORKFLOW_3_1

// WORKFLOW_3_2
const WORKFLOW_3_2_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_3_2_2007_PALSAR`;
const WORKFLOW_3_2_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_radar_data" id="${WORKFLOW_3_2_ID}" x="20" y="13" movable="true">
        <field name="dropdown">PALSAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd_yearly">2007</field>
        <field name="td_yearly">2007</field>
        <comment pinned="false" h="134.4053955078125" w="240.0833740234375">PALSAR is a radar sensor. The mosaic is an average over the year. The dB/DN option simply scales the image differently.</comment>
        <statement name="do">
            <block type="output_radar_vis" id="!Ox/|nwiOrOWyb#~YZd7" >
                <field name="r">HV</field>
                <field name="g">HV</field>
                <field name="b">HV</field>
                <field name="param">.mean()</field>
                <field name="layerName">2007</field>
                <comment pinned="false" h="102.65728759765625" w="253.0283203125">The radar visualisation block has options for HV and HH for PALSAR. These are different polarisation channels.</comment>
            </block>
        </statement>
    </block>
    <block type="input_radar_data" id="${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_3_2_2017_PALSAR" x="20" y="294" movable="true">
        <field name="dropdown">PALSAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd_yearly">2017</field>
        <field name="td_yearly">2017</field>
        <statement name="do">
            <block type="output_radar_vis" id="%:g]oi$w=V1$M9*%33o," >
                <field name="r">HV</field>
                <field name="g">HV</field>
                <field name="b">HV</field>
                <field name="param">.mean()</field>
                <field name="layerName">2017</field>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_3_2_TITLE = 'Observe deforestation in Liberia';
const WORKFLOW_3_2_DESC = 'This workflow uses images taken by a satellite radar sensor called PALSAR. It makes a comparison between two years. Note that the forest is a lighter grey than the agriculture that replaces it. In this way we map areas of deforestation.  You can adjust the years in each to explore the change over time, or choose a different area, or country, to observe the forest loss over time. Recommended areas to investigate:  Sumatra, Indonesia, and The State of Rondonia in Western Brazil.';
const WORKFLOW_3_2_IMG = 'WORKFLOW_3_2.png';
import WORKFLOW_3_2_AREA from './featured_workflows/areas/WORKFLOW_3_2_AREA.js'

let WORKFLOW_3_2_GEOJSON = loadGeojson(WORKFLOW_3_2_AREA)

if(WORKFLOW_3_2_GEOJSON !== false) {
    const WORKFLOW_3_2 = {
        id: WORKFLOW_3_2_ID,
        xml: WORKFLOW_3_2_XML,
        title: WORKFLOW_3_2_TITLE,
        desc: WORKFLOW_3_2_DESC,
        img: WORKFLOW_3_2_IMG,
        area: WORKFLOW_3_2_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_3_2);
}

// EO --- WORKFLOW_3_2

// WORKFLOW_3_3
const WORKFLOW_3_3_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_3_3`;
const WORKFLOW_3_3_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_optical_data" id="${WORKFLOW_3_3_ID}" x="20" y="40" movable="true">
        <field name="dropdown">s2</field>
        <field name="area">Area 1</field>
        <field name="data">_SR</field>
        <field name="fd">2020-01-01</field>
        <field name="td">2020-12-31</field>
        <comment pinned="false" h="127.7874755859375" w="272.30126953125">We start with Sentinel 2 as it has finer detail than Landsat. Try exploring by changing the dates and/or location. </comment>
        <statement name="do">
            <block type="analyse_cloud_filter" >
                <field name="filterType">qa_s2_SR</field>
                <field name="qa_s2_SR_cloud_cover">40</field>
                <next>
                    <block type="analyse_timeseries" id="J%{%:z0s{%yJ)XcMe@u:" >
                        <field name="interval">monthly</field>
                        <comment pinned="false" h="130.4613037109375" w="284.4854736328125">We have chosen a time interval of one month since cloud cover can sometimes limit the total number of available images. </comment>
                        <statement name="statements">
                            <block type="analyse_ndvi" id="f}[jhe9D(]A:.8[IoTIC" >
                                <field name="type">max</field>
                                <comment pinned="false" h="114.53778076171875" w="285.40234375">By choosing the maximum NDVI we are most likely to see the effects of vegetation in the image.</comment>
                                <next>
                                    <block type="output_other_vis" id="Cpra4-.Q%CGghKN)|U@X" >
                                        <field name="layerName">Agriculture NDVI</field>
                                    </block>
                                </next>
                            </block>
                        </statement>
                    </block>
                </next>
            </block>
        </statement>
    </block>
</xml>`;
const WORKFLOW_3_3_TITLE = 'Observing agricultural change';
const WORKFLOW_3_3_DESC = 'This example extracts data over agricultural areas in the "Corn Belt" of the USA to show how we can monitor crop growth. We use the Normalised Difference Vegetation Index (NDVI), which compares the NIR channel to the red channel in each image pixel to highlight the presence of vegetation. The period covers one year from Jan-Dec. The NDVI peaks in about August, just when the crop starts to dry out.';
const WORKFLOW_3_3_IMG = 'WORKFLOW_3_3.png';
import WORKFLOW_3_3_AREA from './featured_workflows/areas/WORKFLOW_3_3_AREA.js'

let WORKFLOW_3_3_GEOJSON = loadGeojson(WORKFLOW_3_3_AREA)

if(WORKFLOW_3_3_GEOJSON !== false) {
    const WORKFLOW_3_3 = {
        id: WORKFLOW_3_3_ID,
        xml: WORKFLOW_3_3_XML,
        title: WORKFLOW_3_3_TITLE,
        desc: WORKFLOW_3_3_DESC,
        img: WORKFLOW_3_3_IMG,
        area: WORKFLOW_3_3_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_3_3);
}

// EO --- WORKFLOW_3_3

// WORKFLOW_4_1
const WORKFLOW_4_1_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_4_1`;
const WORKFLOW_4_1_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_radar_data" id="${WORKFLOW_4_1_ID}_2007_PALSAR" x="20" y="13" movable="true">
        <field name="dropdown">PALSAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd_yearly">2007</field>
        <field name="td_yearly">2007</field>
        <statement name="do">
            <block type="output_radar_vis" id="!Ox/|nwiOrOWyb#~YZd7" >
                <field name="r">HV</field>
                <field name="g">HV</field>
                <field name="b">HV</field>
                <field name="param">.mean()</field>
                <field name="layerName">2007</field>
            </block>
        </statement>
    </block>
    <block type="input_radar_data" id="${WORKFLOW_4_1_ID}_2017_PALSAR" x="20" y="294" movable="true">
        <field name="dropdown">PALSAR</field>
        <field name="param">dB</field>
        <field name="area">Area 1</field>
        <field name="fd_yearly">2017</field>
        <field name="td_yearly">2017</field>
        <statement name="do">
            <block type="output_radar_vis" id="%:g]oi$w=V1$M9*%33o," >
                <field name="r">HV</field>
                <field name="g">HV</field>
                <field name="b">HV</field>
                <field name="param">.mean()</field>
                <field name="layerName">2017</field>
            </block>
        </statement>
    </block>
</xml>
`;
const WORKFLOW_4_1_TITLE = 'Urban expansion';
const WORKFLOW_4_1_DESC = `In this example, radar data from PALSAR is used to observe Lilongwe’s growth from 2007 to 2017.  Radar signals interact strongly with artificial materials such as metals and concrete, and the sharp edges and regular corners of buildings also generate a strong signal in the radar.  Urban areas therefore look brighter in the radar image.
Run this workflow then use the sliders to change the transparency and note how the city has grown.  If you zoom in, you can see how darker areas in 2007 that were barren land, become brighter in 2017 as buildings have been added.  Mapping of urbanisation is important for countries like Malawi as it allows more effective urban planning and development of the necessary infrastructure.`;
const WORKFLOW_4_1_IMG = 'WORKFLOW_4_1.png';
import WORKFLOW_4_1_AREA from './featured_workflows/areas/WORKFLOW_4_1_AREA.js'

let WORKFLOW_4_1_GEOJSON = loadGeojson(WORKFLOW_4_1_AREA)

if(WORKFLOW_4_1_GEOJSON !== false) {
    const WORKFLOW_4_1 = {
        id: WORKFLOW_4_1_ID,
        xml: WORKFLOW_4_1_XML,
        title: WORKFLOW_4_1_TITLE,
        desc: WORKFLOW_4_1_DESC,
        img: WORKFLOW_4_1_IMG,
        area: WORKFLOW_4_1_GEOJSON
    }
    featuredWorkflowsMooc.push(WORKFLOW_4_1);
}

// EO --- WORKFLOW_4_1

// WORKFLOW_4_2
const WORKFLOW_4_2_ID = `${FEATURED_WORKFLOW_BLOCK_PREFIX}WB_4_2`;
const WORKFLOW_4_2_XML = `
<xml xmlns="https://developers.google.com/blockly/xml">
    <block type="input_night_lights" id="JLBs^#{q#bqlHtxf#:x" x="40" y="217" movable="true">
        <field name="dropdown">viirs_corrected</field>
        <field name="area">IN</field>
        <field name="fd">2019-11-30</field>
        <field name="td">2020-12-01</field>
        <statement name="do">
            <block type="output_other_vis" id="h@BKI8o*uGEyDyBID9" >
                <field name="layerName">Night lights</field>
            </block>
        </statement>
    </block>
    <block type="input_anthropogenic" id="${WORKFLOW_4_2_ID}" x="40" y="10" movable="true">
        <field name="dropdown">population_count</field>
        <field name="area">IN</field>
        <statement name="do">
            <block type="output_other_vis" id="YvL+HvKhxnw#vOl2|j_" >
                <field name="layerName">default</field>
            </block>
        </statement>
    </block>
</xml>
`;
const WORKFLOW_4_2_TITLE = 'Night lights';
const WORKFLOW_4_2_DESC = `This example looks at night lights over India and compares them to the concentrations of population. Note how population and night lights broadly match in many locations (especially the big cities) but not in all areas.  Care should always be taken when interpreting night lights as they can vary for many different reasons.  Try changing the country selection to your own country and see if you can identify any unusually sources of night lights.`;
const WORKFLOW_4_2_IMG = 'WORKFLOW_4_2.png';


const WORKFLOW_4_2 = {
    id: WORKFLOW_4_2_ID,
    xml: WORKFLOW_4_2_XML,
    title: WORKFLOW_4_2_TITLE,
    desc: WORKFLOW_4_2_DESC,
    img: WORKFLOW_4_2_IMG,
}
featuredWorkflowsMooc.push(WORKFLOW_4_2);


// EO --- WORKFLOW_4_2

export { featuredWorkflowsMooc }
